import React, { useContext } from "react"
import PropTypes from "prop-types"
import { useDropdownItem } from "@restart/ui/DropdownItem"
import Anchor from "@restart/ui/Anchor"

import { classNames } from "@utils/classNames"
import MetaDropdownContext from "@components/MetaDropdown/Group/MetaDropdownContext"

const propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  as: PropTypes.elementType,
}

const DropdownItem = React.forwardRef(
  (
    {
      className,
      eventKey,
      disabled = false,
      onClick,
      active,
      as: Component = Anchor,
      ...props
    },
    ref
  ) => {
    const prefix = "dropdown-item"
    const [dropdownItemProps, meta] = useDropdownItem({
      key: eventKey,
      href: props.href,
      disabled,
      onClick,
      active,
    })
    const { theme, inverted } = useContext(MetaDropdownContext)

    let background = ""
    switch (theme) {
      case "blue-bg":
        background = inverted
          ? meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-dblue hover:text-mgreen"
          : meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-white hover:text-mgreen"
        break
      case "white-bg":
        background = inverted
          ? meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-white hover:text-mgreen"
          : meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-dblue hover:text-mgreen"
        break
      case "gray-bg":
        background = inverted
          ? meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-white hover:text-mgreen"
          : meta.isActive
            ? "text-mgreen"
            : "bg-transparent text-dblue hover:text-mgreen"
        break
      default:
    }
    return (
      <Component
        {...props}
        {...dropdownItemProps}
        ref={ref}
        className={classNames(
          prefix,
          `block w-full py-2.5 
            px-9 
            clear-both no-underline 
            text-tiny md:text-base text-left 
            font-sans font-normal
            transition-all
            overflow-hidden 
            border-0`,
          className,
          background,
          meta.isActive && "active",
          disabled && "disabled"
        )}
      />
    )
  }
)

DropdownItem.displayName = "DropdownItem"
DropdownItem.propTypes = propTypes

export default DropdownItem